<template>
  <div class="main-content">
    <SectionTitle class="animate-target" v-animate-in :title="title"></SectionTitle>
    <img class="ctn-image animate-target" v-animate-in src="../../assets/images/p4-1/4-1.svg" />
    <div class="content-text">
      <p class="animate-target" v-animate-in>The RACGP type 2 diabetes handbook (2024) summarises this advice<sup>2</sup>:</p>
      <ul>
        <li class="animate-target" v-animate-in>Achieve optimal blood pressure and glycaemic management</li>
        <li class="animate-target" v-animate-in>Support lifestyle management in addition to pharmacological management</li>
        <li class="animate-target" v-animate-in>Advise on lifestyle modifications and weight management</li>
        <li class="animate-target" v-animate-in>Use pharmacological therapies including:
          <ul class="un-line">
            <li class="animate-target" v-animate-in>– Use an ACEi or ARB to the maximally tolerated dose</li>
            <li class="animate-target" v-animate-in>– Consider SGLT2i according to CKD stage</li>
            <li class="animate-target" v-animate-in>– Use a non-steroidal MRA (currently finerenone)</li>
            <li class="animate-target" v-animate-in>– Consider lipid lowering combinations</li>
            <li class="animate-target" v-animate-in>– GLP-1 receptor agonists (GLP-1RAs) with evidence of renal benefits may be appropriate</li>
          </ul>
        </li>
        <li class="animate-target" v-animate-in>Avoid exposure to acute nephrotoxicity via combined NSAIDs, diuretics and ACEi/ARBs</li>
        <li class="animate-target" v-animate-in>Maintain up-to-date immunisations.</li>
        <li class="animate-target" v-animate-in>Provide adults with diabetes and CKD a ‘sick-day’ medication list.</li>
      </ul>
    </div>
    <GoNext class="animate-target" v-animate-in href="/section4/4-2">Next</GoNext>
    <ContentNotice class="animate-target" v-animate-in :txt="noticeTxt"/>
  </div>
</template>

<script>
import SectionTitle from "../../components/SectionTitle";
import GoNext from "../../components/GoNext";
import ContentNotice from "../../components/ContentNotice";
import {mapState} from "vuex";

export default {
  name: "s4-1",
  components: {SectionTitle, GoNext, ContentNotice},
  computed:{
  },
  data(){
    return{
      noticeTxt:"ACE, angiotensin converting enzyme inhibitor; ASCVD, atherosclerotic cardiovascular disease; ARB, Angiotensin receptor blocker; CKD, chronic kidney disease; CVD, cardiovascular disease; GLP-1 RA, glucagon like peptide-1 receptor agonist; HTN, hypertension; KDIGO, Kidney Disease Improving Global Outcomes; MRA, mineralocorticoid receptor antagonist; NSAID, non steroidal anti inflammatory drugs; RACGP, Royal College of General Practitioner; RAS, renin angiotensin system; SGLT-2i, sodium glucose co transporter-2inhibitor; T2D, type 2 diabetes.<br/><div class='brs'></div>"
      +"References:<br/><div class='brs'></div>"
      +"1. KDIGO Diabetes Work Group. Kidney International (2022) 102 (Suppl 5S), S1–S127.<br/>"
      +"2. RACGP. Management of type 2 diabetes: A handbook for general practice. <a class='c-url' target='_blank' href='https://www.racgp.org.au/getattachment/7c05e922-ab1f-4301-aab7-f4f9b638cb66/Management-of-type-2-diabetes-A-handbook-for-general-practice.aspx'>https://www.racgp.org.au/getattachment/7c05e922-ab1f-4301-aab7-f4f9b638cb66/Management-of-type-2-diabetes-A-handbook-for-general-practice.aspx</a>.",
      title:"People with diabetes and chronic kidney disease (CKD) should be treated with a comprehensive approach to improve kidney and cardiovascular outcomes: KDIGO 2022<sup>1</sup>"
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/section4/s4.css";
.ctn-image {
  width: 100%;
  margin-top: 30px;
}
.content-text {
  margin-top: 40px;
}
.content-text p {
  font-size: 20px;
}
.content-text ul {
  margin-top: 20px;
  margin-left: 30px;
  font-size: 20px;
}
.content-text ul li {
  margin-bottom: 15px;
}
.un-line {
  list-style-type: none;
  text-indent: -25px;
}
</style>
